import { render } from "./BackModal.vue?vue&type=template&id=063652ac&scoped=true"
import script from "./BackModal.vue?vue&type=script&lang=js"
export * from "./BackModal.vue?vue&type=script&lang=js"

import "./BackModal.vue?vue&type=style&index=0&id=063652ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063652ac"]])

export default __exports__